import CancelContractGroupItemRequest from './cancel-contract-group-item.request';
import CancelItemRuleRequest from './cancel-item-rule.request';

export default class CancelContractGroupRequest {
  observation: string;

  competence: string;

  cancellations: CancelContractGroupItemRequest[];

  constructor(obj: any = {}) {
    this.observation = obj.observation || '';
    this.competence = obj.competence || '';
    this.cancellations = obj.cancellations
      ? obj.cancellations.map((item: any) => CancelContractGroupItemRequest.of(item))
      : [];
  }

  public static of(obj: any = {}): CancelContractGroupRequest {
    return new CancelContractGroupRequest(obj || {});
  }

  public static ofList(obj: any[]): CancelContractGroupRequest[] {
    return obj.map(this.of);
  }
}
